<template>
  <div @click="progressClick">
    <Forest
        :totalTrees="totalTrees"
        :userTrees="userTrees"
        :open="open"
    ></Forest>
    <goal-progress
        :progress="userTrees"
        :goal="goal"
        :lvl="lvl"
        :open="open" 
    ></goal-progress>
  </div>
</template>
<script>
import Forest from "./Forest.vue";
import GoalProgress from "./GoalProgress.vue";

import axios from "axios";

export default {
    data(){
        return{
           totalTrees: (localStorage.totalTrees) ? localStorage.totalTrees : 0,
           userTrees: (localStorage.userTrees) ? localStorage.userTrees : 0,
           goal: 50,
           lvl: 0,
           open: !(this.$route.name ===  "Home"),
        }
    },
    created(){
        /* eslint-disable no-console*/
      const that = this;

      if (!localStorage.goal){
        localStorage.goal = 50;
      }

      this.goal = localStorage.goal;

      if(!localStorage.lvl)
        localStorage.lvl = 0;

      this.lvl = localStorage.lvl

      console.log("goal", this.goal)

      this.getCounters();
      setInterval(this.getCounters,300000);
      

      window.nativeGoBack = function(){
        // window.history.length > 1 ? router.go(-1) : window.Android.closeApp();
        if (that.$route.name !== 'Home'){
          that.open = false;
          that.$router.push({name:'Home', query: that.$route.query});
        }else if(window.Android){
          window.Android.closeApp();
        }
      }

      window.goHome = function(){
        that.open = false;
        that.$router.push({name:'Home', query: that.$route.query});
      }

      window.goJourney = function(){
        that.open = true;
        that.$router.push({name:'Journey', query: that.$route.query});
      }
    },
    methods:{
        
        async getCounters(){

            var uuid = localStorage.getItem('UUID');
            //removed await... why was it there? I don't get my own reasons
            axios.get('https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees')
            .then(res=>{
                this.totalTrees = res.data.Counter; 
                localStorage.totalTrees = res.data.Counter;
                // this.totalTrees = 1328;
                // console.log(res); 
            });
            //removed await... why was it there? I don't get my own reasons
            axios.get('https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees?userid='+uuid)
            .then(res=>{
              if(res.data.Counter){
                this.userTrees = res.data.Counter;
                localStorage.userTrees = res.data.Counter;
              }         
              // this.userTrees = 36;
              // console.log(res);
              while(this.userTrees >= this.goal){
                this.goal = this.goal * 2;
                localStorage.goal = this.goal;
                localStorage.lvl++;
                console.log("superato!", this.goal)
                console.log("nuovo livello ",localStorage.lvl);
                window.$('#levelupmodal').modal('show');
              }
            });
        },
        progressClick(){
            this.open = !this.open;
            if(this.open)
                this.$router.push({name:'Journey', query: this.$route.query});
            else
                this.$router.push({name:'Home', query: this.$route.query});
        }
    },
  components: {
    Forest,
    GoalProgress
  }
}
</script>